<template>
  <modal :show.sync="modals.classic">
    <h4 slot="header" class="title title-up">{{ $t('app.modules.product_family_prop.add.title')  }}</h4>

    <ValidationObserver ref="formAdd" v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(execAction)">

        <div class="row">
          <div class="col-sm-12">

            <div class="row">
              <div class="col-12">
                <label>{{ $t('app.modules.product_family_prop_group.headers.name') }}</label>
              </div>
              <div class="col-10">
                <el-select v-model="property.grupoPropiedadFamiliaProducto_idGrupoPropiedad"
                           :placeholder="$t('app.modules.product_family_prop_group.headers.name')"
                           size="large" allowCreate
                >
                  <el-option
                    v-for="group in groups"
                    :key="group.idGrupoPropiedad"
                    :label="group.nombreGrupo"
                    :value="group.idGrupoPropiedad">
                  </el-option>
                </el-select>
              </div>
              <div class="col-2">
                <n-button
                  class="btn like btn-md"
                  type="success"
                  :title="$t('app.buttons.add')"
                  round
                  icon
                  @click.native="openGroupAdd()"
                  size="md">
                  <i class="fa fa-plus"></i>
                </n-button>
              </div>
            </div>

            <div class="separate"></div>

            <div v-for="lang in property.traducciones">
              <h6>{{ lang.idioma.idioma }}</h6>
              <div class="row">
                <div class="col-12">
                  <fg-input
                    type="text"
                    name="minLength"
                    :label="$t('app.modules.product_family_prop.headers.name')"
                    v-model="lang.nombrePropiedad"
                  >
                  </fg-input>
                </div>
              </div>
              <div class="separate"></div>
            </div>

            <div class="row">
              <div class="col-8">
                <el-select v-model="property.tipo" :placeholder="$t('app.modules.product_family_prop.headers.content_type')" size="large">
                  <el-option
                    v-for="type in types"
                    :key="type"
                    :label="$t('app.modules.product_family_prop.headers.'+type.name)"
                    :value="type.name">
                  </el-option>
                </el-select>
              </div>
              <div class="col-4 is-center" style="text-align: center">
                {{ $t("app.general.active") }} <br />
                <n-switch v-model="property.activo"></n-switch>
              </div>
            </div>
          </div>
        </div>

        <div
          slot="footer"
          style="margin-top: 10px; padding-top: 20px;border-top: outset;"
          class="text-right"
        >
          <n-button class="pull-left btn-secondary" @click.native="cancelAdd()">{{ $t("app.buttons.cancel") }}</n-button>
          <n-button native-type="submit" type="primary">{{ $t("app.buttons.save") }}</n-button>
        </div>
      </form>
    </ValidationObserver>
    <grupo-propiedad-familia-producto-add></grupo-propiedad-familia-producto-add>
  </modal>
</template>

<script>
import { extend } from "vee-validate";
import { min, required } from "vee-validate/dist/rules";
import GrupoPropiedadFamiliaProductoAdd from "src/pages/views/grupoPropiedadFamiliaProducto/grupoPropiedadFamiliaProductoAdd";
import {mapState} from "vuex";
import {getResponse} from "@/util/utilities";
import Idioma from "@/models/familiaProducto/Idioma";
import PropiedadFamiliaProductoTraduccion from "@/models/familiaProducto/PropiedadFamiliaProductoTraduccion";

extend("required", required);
extend("min", min);

export default {
  components: {
    GrupoPropiedadFamiliaProductoAdd
  },
  computed: {
    ...mapState(["user", "availableLangs"]),
  },
  created () {

  },
  data () {
    return {
      modals: {
        classic: false,
        notice: false,
        mini: false
      },
      groups: [],
      property: {
        idPropiedadFamiliaProducto: 0,
        activo: true,
        tipo: "image",
        grupoPropiedadFamiliaProducto_idGrupoPropiedad: 0,
        traducciones: []
      },
      types: [
        {name: "image"},
        {name: "text"},
        {name: "file"},
      ],
      action: "new"
    };
  },
  mounted() {
    this.property.claveIdioma = this.$store.state.lang;
    this.property.usuarios_IdUsuario = this.user.idUsuario;
    this.property.traducciones = this.availableLangs.map((lang) => new PropiedadFamiliaProductoTraduccion({
      idFamiliaProductoTraduccion: Math.random(),
      nombrePropiedad: "",
      idiomas_idIdioma: lang.idIdioma,
      idioma: new Idioma({
        idIdioma: lang.idIdioma,
        idioma: lang.idioma,
        clave: lang.clave
      })
    }));

    this.init();
    EventBus.$on("propiedadFamiliaProductoAdd",  () => {
      this.action = "new";
      this.$swal.fire({
        title: "Por favor espera",
        html:
          '<div class="spinner-border text-primary" style="width: 3rem; height: 3rem;" role="status"><span class="sr-only">Loading...</span></div>',
        showConfirmButton: false
      });
      this.$swal.close();
      this.modals.classic = true;
    });
    EventBus.$on("propiedadFamiliaProductoEdit",  (item) => {
      this.action = "update";
      this.$swal.fire({
        title: "Por favor espera",
        html:
          '<div class="spinner-border text-primary" style="width: 3rem; height: 3rem;" role="status"><span class="sr-only">Loading...</span></div>',
        showConfirmButton: false
      });
      this.$swal.close();

      this.property.idPropiedadFamiliaProducto = item.idPropiedadFamiliaProducto;
      this.property.activo = item.activo;
      this.property.tipo = item.tipo;
      this.property.grupoPropiedadFamiliaProducto_idGrupoPropiedad = item.grupoPropiedadFamiliaProducto_idGrupoPropiedad;
      this.property.traducciones = item.traducciones;

      this.modals.classic = true;
    });
    EventBus.$on("update-group", () => {
      this.loadGroups();
    });
  },
  methods: {
    init() {
      let self = this;
      this.$swal.fire({
        title: self.$t("app.promps.wait"),
        html:
          '<div class="spinner-border text-primary" style="width: 3rem; height: 3rem;" role="status"><span class="sr-only">Loading...</span></div>',
        showConfirmButton: false
      });

      this.loadGroups();

      this.$swal.close();
    },
    async loadGroups() {
      let payload = {
        id: 0,
        claveIdioma: this.$store.state.lang,
        usuario: 0
      };

      let request = await this.$http.post(route("GrupoPropiedadFamiliaProducto/getGrupoPropiedadFamiliaProducto"), payload)
      let response = getResponse(request, null);

      if(response != null){
        this.groups = response.grupoPropiedadFamiliaProductos;
        if(this.groups.length > 0){
          this.property.grupoPropiedadFamiliaProducto_idGrupoPropiedad = this.groups[0].idGrupoPropiedad;
        }
      }
      else this.notifyMessage("danger", self.$t("app.promps.error"));
    },
    openGroupAdd() {
      EventBus.$emit("grupoPropiedadFamiliaProductoAdd");
    },
    cancelAdd() {
      let self = this;
      this.property.idPropiedadFamiliaProducto = 0;
      this.property.activo = true;
      this.property.tipo = "image";

      if(this.groups.length > 0){
        this.property.grupoPropiedadFamiliaProducto_idGrupoPropiedad = this.groups[0].idGrupoPropiedad;
      }

      this.property.traducciones = this.availableLangs.map((lang) => new PropiedadFamiliaProductoTraduccion({
        idFamiliaProductoTraduccion: Math.random(),
        nombrePropiedad: "",
        idiomas_idIdioma: lang.idIdioma,
        idioma: new Idioma({
          idIdioma: lang.idIdioma,
          idioma: lang.idioma,
          clave: lang.clave
        })
      }));

      this.modals.classic = false;
    },
    async execAction()
    {
      this.$swal.fire({
        title: "Por favor espera",
        html:
          '<div class="spinner-border text-primary" style="width: 3rem; height: 3rem;" role="status"><span class="sr-only">Loading...</span></div>',
        showConfirmButton: false
      });

      try
      {
        this.property.traducciones.forEach(t => {
          if(!t.nombrePropiedad) throw new Error(this.$t('app.modules.product_family_prop.errors.no_name') + ": " + t.idioma.idioma);
        });

        let response;
        switch (this.action){
          case "new": response = await this.addProp(); break;
          case "update": response = await this.editProp(); break;
        }

        if(response){
          this.notifyMessage("success", this.$t("app.promps.save_success"));
          EventBus.$emit("updated-complete");
          this.cancelAdd();
        }
        else this.notifyMessage("danger", this.$t("app.promps.error"));
      }
      catch (e){
        this.notifyMessage('danger', e.message);
      }
      finally
      {
        this.$swal.close();
      }
    },
    async addProp ()
    {
      let request = await this.$http.post(route("PropiedadFamiliaProducto/addPropiedadFamiliaProducto"), this.property);
      return getResponse(request, null);
    },
    async editProp()
    {
      let request = await this.$http.put(route("PropiedadFamiliaProducto/updatePropiedadFamiliaProducto"), this.property);
      return getResponse(request, null);
    }
  }
}
</script>

<style>
.el-select-dropdown.el-popper {
  border-radius: 10px !important;
}
.modal-content .modal-header {
  padding-bottom: 24px!important;
  box-shadow: 0px 2px 5px 0px #00000021!important;
}

</style>
<style scoped>
.el-select--large {
  width: 100% !important;
}
.separate {
  height: 1px;
  background: #f1f1f1;
  margin: 15px 0;
}
.has-success.has-label:after, .has-danger.has-label:after {
  top: 42px;
}

</style>
